import { createAction } from '@reduxjs/toolkit';

export const openModal = createAction<{ modalType: string; modalProps: any }>('MODALS/OPEN');

export const closeModal = createAction('MODALS/CLOSE');

export const clearAllModals = createAction('MODALS/CLEAR_ALL');
